document.addEventListener('DOMContentLoaded', function () {

    const elements = document.querySelectorAll('.animate-on-scroll');
    
    function animateOnScroll() {
        const viewportHeight = window.innerHeight;

        // Handle individual elements
        elements.forEach(function (element) {
          const elementTop = element.getBoundingClientRect().top;
            if (elementTop < viewportHeight * 0.66) {
                element.classList.add('aos-animate');
            }
        });
    }

    window.addEventListener('scroll', animateOnScroll);
    animateOnScroll(); // Trigger on load
});